import { Avatar, Box, HStack, StackProps, Text } from '@chakra-ui/react';
import IconHashtag from 'assets/icons/icon-hashtag.svg?react';

type Props = StackProps & {
  name: string,
  colorScheme: string,
  description: string
}

export default function TagHeader({ name, colorScheme, description, ...props }: Props) {
  return (
    <HStack 
      spacing="13px"
      {...props}
    >
      <Avatar icon={<IconHashtag />} bgColor={colorScheme} />
      <Box>
        <Text as="strong">{name}</Text><br />
        <Text as="span">{description}</Text>
      </Box>
    </HStack>
  )
}
